import { fetchWithAuth } from "@/providers/auth-provider";
import { ServiceResponse } from "@/types/services";
import { OnboardingInput, OnboardingOutput } from "types/web-app";

export const callOnboarding = async (
  accessToken: string,
  input: OnboardingInput,
): Promise<ServiceResponse<OnboardingOutput | null>> => {
  try {
    const response = await fetchWithAuth("/onboarding", accessToken, {
      method: "POST",
      body: JSON.stringify(input),
    });

    const data = (await response.json()) as ServiceResponse<OnboardingOutput>;
    console.log(`onboarding fetch Data`, data);
    return data;
  } catch (error) {
    console.error("Failed to call onboarding:", error);
    return {
      statusCode: 500,
      message: "Failed to process onboarding request",
      ok: false,
      data: null,
    };
  }
};
